import { ButtonPrimary, ButtonTertiary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { TrainSidePanelDetails } from "./TrainSidePanelDetails";

export interface TrainSidePanelProps {
  trainSegmentId: number
  trigger: JSX.Element
}

export const TrainSidePanel = (props: TrainSidePanelProps) => {
  return <DetailSidePanel<server.dto.LegacyTrain>
    apiCall={async () => {
      // TODO: This is a short workaround unitl we migrate train pages
      const resp = await window.Api.Trains.GetTrainBySegment(props.trainSegmentId);
      return Promise.resolve({
        data: {
          data: resp.data,
          hasErrors: false,
          errors: [],
          pagination: null,
        },
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
      });
    }}
    apiKey="train-segment"
    entityId={props.trainSegmentId}
    title={RESX.Train.resxTrain}
    footerContent={train => <>
      <ButtonPrimary href={routes.train_Detail(train.id).absolute} label={RESX.Buttons.DetailView} />
      {train.permissions.canModify && <ButtonTertiary
        onClick={() => SystemOneLibrary.exports.openModalAndEditSegment(props.trainSegmentId)}
        label={RESX.Buttons.btnEdit}
      />}
    </>}
    trigger={props.trigger}
  >
    {(train) => <TrainSidePanelDetails
      train={train}
      trainSegmentId={props.trainSegmentId}
    />}
  </DetailSidePanel>
};